import sketchpad from './sketchpad';
import tagpad from './tagpad';
import codereader from './codereader';
import dynamicWizard from './dynamicWizard';
import datatable from './datatable';
import reviewpage from './reviewpage';
import premiumsignature from './premiumsignature';
export default {
    sketchpad: sketchpad,
    tagpad: tagpad,
    codereader: codereader,
    dynamicWizard: dynamicWizard,
    datatable: datatable,
    reviewpage: reviewpage,
    premiumsignature: premiumsignature
};
